import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/locales'

Vue.use(VueI18n)

class CustomFormatter{
  constructor () {}

  // eslint-disable-next-line no-unused-vars
  interpolate (message, values, path) {
    if(!message || message === path){
      return ['']
    }

    return null
  }
}

//i18n配置
const language = navigator.language || navigator.browserLanguage
const lang = localStorage.getItem('language') || (language == 'zh-CN' ? 'zh' : 'en')
const i18n = new VueI18n({ locale: lang, fallbackLocale: lang, formatter: new CustomFormatter(), formatFallbackMessages: true, messages })

//语言切换函数
i18n.$locale = language => {
  i18n.locale = language
  localStorage.setItem('language', language)
  document.title = i18n.t('base.title')
}
i18n.$locale(lang)

export default i18n
